(() => {
  const initialized = new WeakSet();
  let pending = false;
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const shippingDate = days => {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/Chicago',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const value = type => Number(parts.find(part => part.type === type).value);
    const date = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + days, 12));
    return new Intl.DateTimeFormat('en-US', {month:'long',day:'numeric',timeZone:'UTC'}).format(date);
  };
  const chooseDefault = (select, pattern) => {
    if (!select || initialized.has(select)) return;
    if (select.value.trim()) { initialized.add(select); return; }
    const option = Array.from(select.options).find(item => pattern.test(item.textContent));
    if (!option) return;
    initialized.add(select);
    select.value = option.value;
    select.dispatchEvent(new Event('change', {bubbles:true}));
  };
  const update = () => {
    pending = false;
    document.querySelectorAll('[data-rooney-purchase]').forEach(box => {
      const scope = box.closest('.product__info-container');
      if (!scope) return;
      const style = scope.querySelector('select[name="properties[Choose Your Font Style]"]');
      const turnaround = scope.querySelector('select[name="properties[Turnaround Time]"]');
      if (!style && !turnaround) return;
      scope.classList.add('rooney-personalized');
      if (box.dataset.appliqueDefault === 'true') chooseDefault(style, /applique name/i);
      const currentTurnaround = scope.querySelector('select[name="properties[Turnaround Time]"]');
      const total = box.querySelector('[data-rooney-total]');
      const regular = scope.querySelector('.product__price .price__regular .price-item--regular');
      const sale = scope.querySelector('.product__price .price--on-sale .price-item--sale');
      const price = (sale || regular)?.textContent.trim();
      if (price) { setText(total, box.dataset.selectedTotal + ' ' + price); total.hidden = false; }
      const cover = box.querySelector('[data-rooney-cover]');
      const insert = Array.from(scope.querySelectorAll('input[type="checkbox"]')).find(input => /insert/i.test(input.name));
      cover.hidden = Boolean(insert?.checked);
      const dispatch = box.querySelector('[data-rooney-dispatch]');
      const transit = box.querySelector('[data-rooney-transit]');
      const rush = box.querySelector('[data-rooney-rush]');
      const rushOption = Array.from(currentTurnaround?.options || []).find(option => /rush/i.test(option.textContent));
      const rushSelected = /rush/i.test(currentTurnaround?.value || '');
      setText(dispatch, box.dataset.standardToday + ' ' + shippingDate(28));
      dispatch.hidden = false;
      dispatch.classList.toggle('rooney-dispatch', !rushSelected);
      transit.hidden = false;
      if (rushOption) {
        const feeMatch = rushOption.textContent.match(/\+\s*\$\s*([\d,.]+)/);
        const fee = feeMatch ? '+$' + feeMatch[1] : '';
        const offer = fee ? box.dataset.rushOffer.replace('__FEE__', fee) : box.dataset.rushOffer.replace(' (__FEE__)', '');
        setText(rush, (rushSelected ? box.dataset.rushSelected : offer) + ' ' + shippingDate(14));
        rush.hidden = false;
        rush.classList.toggle('rooney-dispatch', rushSelected);
      } else {
        rush.hidden = true;
      }
    });
    document.querySelectorAll('[data-rooney-cart-days]').forEach(node => {
      setText(node, node.dataset.orderToday + ' ' + shippingDate(Number(node.dataset.rooneyCartDays)));
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,characterData:true});
  update();
})();
